<template>
  <layout-main-inner title="会员设置">
    <member-level-table
      ref="level"
      :vendorId="userInfo.orgId"
      :callback="callback" />
    <level-score-table
      ref="score"
      :vendorId="userInfo.orgId" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import MemberLevelTable from './busi/member-level-table.vue'
import LevelScoreTable from './busi/level-score-table.vue'
export default {
  name: 'MemberSettings',
  components: { MemberLevelTable, LevelScoreTable },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() { },
  methods: {
    callback() {
      this.$refs.score.fetch()
    }
  }
}
</script>
